import { ColumnDef } from "@tanstack/react-table";
import { EditIcon } from "assets/icons";
import { Media } from "components";
import { useLanguage } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import { useMemo, useState } from "react";
import { DateTableCell, ItemsTable, TableItemActionsControl } from "ui";

import { AnnouncementsHistoryListItem } from "../../content.types";
import { AnnouncementsTableProps } from "./AnnouncementsTable.types";

import styles from "./AnnouncementsTable.module.scss";

const AnnouncementsTable = ({
  announcementsHistory,
  isLoading,
  canUpdateLastAnnouncement,
  setEditableAnnouncement
}: AnnouncementsTableProps) => {
  const { currentLanguage } = useLanguage();
  const [openedItemOptionsIndex, setOpenedItemOptionsIndex] = useState<
    number | null
  >(null);

  const columns: Array<
    ColumnDef<AnnouncementsHistoryListItem, AnnouncementsHistoryListItem[]>
  > = useMemo(
    () => [
      {
        header: t("Media"),
        enableSorting: false,
        size: 10,
        minSize: 10,
        cell: ({ row }) => {
          return row.original.image ? (
            <Media
              className={styles.announcementsTable_mediaThumb}
              mediaClassName={styles.announcementsTable_media}
              mediaFile={row.original.image}
            />
          ) : (
            "-"
          );
        }
      },
      {
        id: "title",
        header: t("Title"),
        size: 25,
        minSize: 25,
        cell: ({ row }) => (
          <span className={styles.announcementsTable_boldText}>
            {row.original.title}
          </span>
        )
      },
      {
        id: "text",
        header: t("Text"),

        size: 45,
        minSize: 45,
        cell: ({ row }) => (
          <span className={styles.announcementsTable_text}>
            {row.original.text}
          </span>
        )
      },

      {
        id: "createdAt",
        header: t("Created At"),
        size: 10,
        minSize: 10,
        cell: ({ row }) => <DateTableCell date={row.original.createdAt} />
      },
      {
        id: "shownToResellersUntil",
        header: t("Shown until"),
        size: 10,
        minSize: 10,
        cell: ({ row }) => (
          <DateTableCell date={row.original.shownToResellersUntil} />
        )
      },
      {
        accessorKey: "dotsColumn",
        header: () => null,
        size: 4,
        minSize: 4,
        cell: ({ row }) =>
          row.index === 0 && canUpdateLastAnnouncement ? (
            <TableItemActionsControl
              actionsList={[
                {
                  label: t("Change"),
                  Icon: <EditIcon fill={"#090914"} width={18} height={18} />,
                  onClick: () => {
                    setEditableAnnouncement(row.original);
                  }
                }
              ]}
              rowIndex={row.index}
              setOpenedItemOptionsIndex={setOpenedItemOptionsIndex}
              openedItemOptionsIndex={openedItemOptionsIndex}
            />
          ) : null,
        enableSorting: false
      }
    ],
    [announcementsHistory, openedItemOptionsIndex, currentLanguage]
  );

  return (
    <ItemsTable
      columns={columns}
      data={announcementsHistory}
      skeletonHeight={65}
      isLoading={isLoading}
    />
  );
};

export default AnnouncementsTable;
